import { useRef, useMemo } from "react";
import Link from "next/link";
import styles from './children.module.css';
import LazyImage from "components/LazyImage";
import interpretThumbnail from "lib/interpretThumbnail";
import { ResultThumbnail } from "lib/types";

const PropertyRow = ({ id, loggedIn, url_fragment, sponsored, scheme_uri, url, name, images, size_ft_max, size_m_max, rent_pa, address, rep, availability, marketedBy = [], type, category, searchPortfolio = false, parentThubmnails, sizeMeasurementType }) => {
  const propertyLinkRef = useRef<HTMLAnchorElement>(null);
  let propertyUri = url_fragment || id;
  const thumbnailProps = useMemo(() => {
    if (images) {
      return interpretThumbnail(images, name || address);
    } else {
      return parentThubmnails;
    }
  }, [images, name, parentThubmnails, address]);

  const urlFormat = `/scheme/${scheme_uri}/property/${propertyUri}`
  return (
    <li className={styles.childContainer} onClick={(e) => {
      if ((e.target as HTMLElement).tagName !== "BUTTON" && (e.target as HTMLElement).tagName !== "A") {
        propertyLinkRef?.current?.click();
      }
    }}
    >
      <div className={`${styles.childImage} ${styles.thumbNail}`}>
        <LazyImage
          {...thumbnailProps}
          sizes={"10vw"}
        />
      </div>

      <Link href={`${url || urlFormat}`} passHref prefetch={false} legacyBehavior >
        <a
          className={`${styles.cardHeading} ${styles.ChildCardHeading}`}
          ref={propertyLinkRef}
          aria-label={`View ${name} on Completely Retail`}
          onClick={(e) => {
          }}
        >
          <h2 itemScope itemType="https://schema.org/Place">
            <address title={`${name} ${address}`} itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
              <meta itemProp="streetAddress" content={`${name} ${address}`} />
              <meta itemProp="addressCounty" content="GB" />
              <span>{name}</span>
            </address>
          </h2>
        </a>
      </Link>

      <div className={`${styles.statsTray}`}>
        <div className={styles.statsTrayChild}>
          {availability && (
            <div className={styles.tagTitle}>Availability: <span>{availability.join(' / ')}</span></div>
          )}
          {(sizeMeasurementType.value === 'size_ft_max' && size_ft_max) && (
            <div className={styles.tagTitle}>Size: <span>{size_ft_max ? parseInt(size_ft_max).toLocaleString() : "--"} sq ft</span></div>
          )}
          {(sizeMeasurementType.value === 'size_m_max' && size_m_max) && (
            <div className={styles.tagTitle}>Size: <span>{size_m_max ? parseInt(size_m_max).toLocaleString() : "--"} sq m</span></div>
          )}
          {rent_pa && (
            <div className={styles.tagTitle}>Rent: <span>{rent_pa ? `£${parseInt(rent_pa).toLocaleString()}` : "POA"}</span></div>
          )}
        </div>

        <Link href={`/scheme/${scheme_uri}/property/${url_fragment}`} passHref prefetch={false} >
          <button className={styles.primaryButton}>View details</button>
        </Link>

      </div>
    </li>
  );
};

type ChildrenProps = {
  ids: string[];
  searchName: string;
  sponsored?: boolean;
  show?: boolean;
  properties: any[];
  parentThubmnails: ResultThumbnail;
  loggedIn: boolean;
  scheme_uri: string;
  address: string;
  sizeMeasurementType: string
};

const Children = ({ properties, loggedIn, ids, show = true, sponsored = false, parentThubmnails, scheme_uri, address, sizeMeasurementType }: ChildrenProps) => {
  return (
    <>
      {properties.map((property, i) => (
        <PropertyRow key={property.id} loggedIn={loggedIn} address={address} sponsored={sponsored} scheme_uri={scheme_uri} {...property} size={property.size_ft_max} parentThubmnails={parentThubmnails} sizeMeasurementType={sizeMeasurementType} />
      ))}
    </>

  );
};

export default Children;
